import {createBrowserHistory} from 'history';

import marketService from '@/services/marketService';

let history;

const getHistory = () => {
    if (!history) {
        history = createBrowserHistory({
            basename: marketService.getMarketCode(),
        });
    }

    return history;
};

export default {
    getHistory,
};
